var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26869 9.06774C1.55021 9.34891 1.93182 9.50684 2.3297 9.50684C2.72758 9.50684 3.10919 9.34891 3.39071 9.06774L8.83589 3.62255L14.2811 9.06774C14.5657 9.33295 14.9421 9.47733 15.3311 9.47047C15.7201 9.46361 16.0912 9.30603 16.3663 9.03095C16.6414 8.75586 16.799 8.38473 16.8058 7.99576C16.8127 7.60679 16.6683 7.23034 16.4031 6.94572L9.8969 0.439525C9.61538 0.158357 9.23377 0.000426292 8.83589 0.000426292C8.43801 0.000426292 8.0564 0.158357 7.77488 0.439525L1.26869 6.94572C0.987519 7.22724 0.82959 7.60885 0.82959 8.00673C0.82959 8.40461 0.987519 8.78622 1.26869 9.06774Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.20f43cf3.svg";
export { ForwardRef as ReactComponent };